import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-527e28e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: /*#__PURE__*/_normalizeClass(['select__icon', 'ion-ios-arrow-down'])
}, null, -1))
const _hoisted_3 = {
  class: "select__options",
  role: "list"
}
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "select__select",
      role: "listbox",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onSelectClick && _ctx.onSelectClick(...args)))
    }, [
      _createTextVNode(_toDisplayString(_ctx.selectedOption.name) + " ", 1),
      _hoisted_2
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(['select__options-container', {'select__options-container--open':_ctx.isOpen}])
    }, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "select__option",
            role: "option",
            onClick: ($event: any) => (_ctx.onOptionClick(option)),
            key: option.value
          }, _toDisplayString(option.name), 9, _hoisted_4))
        }), 128))
      ])
    ], 2)
  ]))
}